import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-dlg-campana-detail',
  templateUrl: './dlg-campana-detail.component.html',
  styleUrls: ['../dlg-campana.component.scss']
})
export class DlgCampanaDetailComponent {

  @Input() grupoVal: FormGroup;
  @Input() estados: any[];
  @Input() medios: any[];
  @Input() tipos: any[];
  @Input() tipclis: any[];
  @Input() tipcargas: any[];
  @Input() filteredOptions: any;
  @Input() isLoadingEje: boolean;
  @Input() minDate: Date;

  @Output() autorizarRequested = new EventEmitter<void>();
  @Output() noAutorizarRequested = new EventEmitter<void>();
  @Output() scriptCargado = new EventEmitter<any>();
  @Output() scriptInputOpened = new EventEmitter<void>();

  displayFn(eje?: any): string | undefined {
    if (eje) { return eje.nombre; }
  }

  getError(type) {
    if (type == 1) {
      if (this.grupoVal.controls.eje.hasError('required')) {
        return 'Debes seleccionar un Eje';
      }
    }
    else if (type == 2) {
      if (this.grupoVal.controls.nombre.hasError('required')) {
        return 'Debes ingresar un Nombre';
      }
    }
    else if (type == 3) {
      if (this.grupoVal.controls.estado.hasError('required')) {
        return 'Debes seleccionar una Estado';
      }
    }
    else if (type == 4) {
      if (this.grupoVal.controls.medio.hasError('required')) {
        return 'Debes seleccionar un Medio';
      }
    }
    else if (type == 5) {
      if (this.grupoVal.controls.scripturl.hasError('required')) {
        return 'Debes ingresar un Script';
      }
    }
    else if (type == 6) {
      if (this.grupoVal.controls.fechaini.hasError('required')) {
        return 'Debes seleccionar una Fecha Inicial Valida';
      }
    }
    else if (type == 7) {
      if (this.grupoVal.controls.fechafin.hasError('required')) {
        return 'Debes seleccionar una Fecha Final Valida';
      }
    }
    else if (type == 8) {
      return 'Debes ingresar un porcentaje entre 0 y 100';
    }
    else if (type == 9) {
      return 'Debes ingresar un un valor numerico';
    }
    else if (type == 15) {
      if (this.grupoVal.controls.tipoalta.hasError('required')) {
        return 'Debes seleccionar Tipo alta';
      }
    }
  }

  autorizar() {
    this.autorizarRequested.emit();
  }

  noAutorizar() {
    this.noAutorizarRequested.emit();
  }

  CargarScript(event) {
    this.scriptCargado.emit(event);
  }

  openInputScript() {
    this.scriptInputOpened.emit();
  }
}
